import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Swap broken product images for a neutral placeholder instead of the browser's broken-image icon
const IMG_FALLBACK = "data:image/svg+xml;utf8," + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect width="100" height="100" fill="#e2e8f0"/><path d="M30 65l12-15 9 11 7-8 12 12z" fill="#94a3b8"/><circle cx="62" cy="38" r="6" fill="#94a3b8"/></svg>'
);
window.addEventListener("error", (e) => {
  const el = e.target;
  if (el instanceof HTMLImageElement && el.src !== IMG_FALLBACK) {
    el.src = IMG_FALLBACK;
    el.alt = "";
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
